<template>
  <vxe-modal size="mini" title="提示" v-model="formVisible" width="300px" @show="showModal">
    <div>
      <div style="width: 100%;font-size: 16px;text-align: left">
        <span>是否确认审核通过?</span>
      </div>
      <div style="width: 100%;margin:5px 0 10px 0;">
        <el-checkbox v-model="managerReview">总经理审批</el-checkbox>
      </div>
    </div>
    <div style="display: flex; justify-content: flex-end">
      <el-button
        size="mini"
        @click="
          () => {
            formVisible = false
          }
        "
        >取消</el-button
      >
      <el-button
        type="primary"
        size="mini"
        @click="
          () => {
            $emit('sureHandler', managerReview)
          }
        "
        >确定</el-button
      >
    </div>
  </vxe-modal>
</template>
<script>
export default {
  data() {
    return {
      formVisible: false,
      managerReview: false
    }
  },
  methods: {
    showModal() {
      this.managerReview = false
    }
  }
}
</script>
<style lang="less" scoped></style>
